<template>
    <div class="container">
        <br /><br />
        <div v-if="isShared" class="jumbotron">
            <h1 class="display-4">Shares of {{resourceName}}</h1>
            <p class="lead">You shared <strong>{{resourceName}}</strong> owned by <strong>{{organizationName}}</strong> data in TransparentChoice application</p>
            <hr>

            <div v-for="s in sharesExt" :key="s.Id">
                <div v-if="s.IsPaused" class="row text-muted">
                    <div class="col-sm-9">
                        {{s.Title}}&nbsp;<span class="fg-color-orange">(paused)</span><br />
                        <a>{{s.ShareUrl}}</a>
                    </div>
                    <div class="col-sm-3">
                        <a :href="`/#/sharing/share/${resourceProviderName}/${resourceId}/${s.ShareId}`" class="btn btn-primary pull-right">Manage</a>
                    </div>
                </div>

                <div v-else-if="s.Expired" class="row">
                    <div class="col-sm-9 text-muted">
                        {{s.Title}}&nbsp;<span class="fg-color-red">(expired)</span><br />
                        <a>{{s.ShareUrl}}</a>
                    </div>
                    <div class="col-sm-3">
                        <a :href="`/#/sharing/share/${resourceProviderName}/${resourceId}/${s.ShareId}`" class="btn btn-primary pull-right">Manage</a>
                    </div>
                </div>

                <div v-else class="row">
                    <div class="col-sm-9">
                        {{s.Title}}<br />
                        <div class="input-group input-group-sm mb-3">
                            <input :value="s.Copied ? 'COPIED!' : s.ShareUrl" type="text" class="form-control bg-white" :class="{'text-success': s.Copied}" readonly>
                            <div class="input-group-append">
                                <button @click="handleCopyToClipboard(s)" class="btn btn-outline-secondary" type="button">
                                    <span class="fa fa-copy"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <a :href="`/#/sharing/share/${resourceProviderName}/${resourceId}/${s.ShareId}`" class="btn btn-primary">Manage</a>
                        <a v-if="s.SharedWith?.length>0" :href="`/#/sharing/share/notification/${s.ShareId}`" class="btn btn-secondary">
                            <i class="fa-regular fa-paper-plane"></i>
                        </a>
                    </div>
                </div>
                <hr />
            </div>
            <br />

            <a :href="manageUrl" class="btn btn-lg btn-secondary">Go to {{resourceName}}</a>

            <a :href="`/#/sharing/share/${resourceProviderName}/${resourceId}/${newShareId}`" class="btn btn-lg btn-success pull-right">New Share</a>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from '@common/composables'
    import { useResourcePage } from '@DataSharing/Shares/pages-core'
    import { copyToClipboard } from "@common/Common";

    document.title = 'Share data'

    const route = useRoute()
    const provider = route.params.provider

    const id = ref()
    const organizationUnitId = ref()
    const workspaceId = ref()
    const projectId = ref()
    const sharedBy = ref()
    const sharedWith = ref()
    const resourceProviderName = ref(provider)
    const resourceId = ref(route.params.resourceId)
    const emailsProviderName = ref()
    const emailsProviderConfig = ref()
    const copied = ref<string[]>([])

    const { useResourceSharesQuery } = useResourcePage()

    const { modelResourceSharesQueryV1, runResourceSharesQueryV1 } = useResourceSharesQuery(provider, resourceId.value)

    const shares = computed(() => modelResourceSharesQueryV1.value?.Shares || [])
    const isShared = computed(() => modelResourceSharesQueryV1.value && shares.value.length > 0)
    const newShareId = computed(() => modelResourceSharesQueryV1.value?.NewShareId)
    const organizationName = computed(() => modelResourceSharesQueryV1.value?.OrganizationUnitName)
    const workspaceName = computed(() => modelResourceSharesQueryV1.value?.WorkspaceName)
    const projectName = computed(() => modelResourceSharesQueryV1.value?.ProjectName)
    const resourceName = computed(() => modelResourceSharesQueryV1.value?.ResourceName)
    const resourceUrl = computed(() => modelResourceSharesQueryV1.value?.ResourceUrl)
    const manageUrl = computed(() => modelResourceSharesQueryV1.value?.ManageUrl)

    const sharesExt = computed(() => shares.value.map(_ => Object.assign({}, _, {
        Copied: copied.value.find(c => c == _.ShareId) != undefined
    })))

    function handleCopyToClipboard(share: any) {
        copyToClipboard(share.ShareUrl)
        copied.value.push(share.ShareId)

        const h = setTimeout(() => {{
            copied.value = copied.value.filter(_ => _ != share.ShareId)
            clearTimeout(h)
        }}, 1000)
    }

    onMounted(() => runResourceSharesQueryV1())

    watch(modelResourceSharesQueryV1, () => {
        const model = modelResourceSharesQueryV1.value
        id.value = model?.ShareId
        organizationUnitId.value = model?.OrganizationUnitId
        workspaceId.value = model?.WorkspaceId
        projectId.value = model?.ProjectId
        sharedBy.value = model?.AuthenticatedEmail
        emailsProviderName.value = model?.EmailsProviderName
        emailsProviderConfig.value = model?.EmailsProviderConfig
    })

    watch(isShared, () => {
        if (!isShared.value) {
            location.href = `/#/sharing/share/${resourceProviderName.value}/${resourceId.value}/${newShareId.value}`
        }
    })
</script>
